/**
 * Which release this browser has opened — the one thing the bar needs for its dot.
 *
 * Apart from `releases.ts` on purpose. That module imports every month's notes, and the bar
 * is on every screen of every person: importing it there put the release notes, which show
 * screens a dispatcher is refused, in the bundle every dispatcher downloads. The bar imports
 * this; the notes are fetched only by somebody they are for.
 */

const SEEN_KEY = 'taxi.console.whatsNewSeen';

/** Fired on the window when a release is opened, so the bar can drop its dot without a reload. */
export const SEEN_EVENT = 'taxi:whats-new-seen';

/**
 * The release last opened here, null when none has been — or undefined when storage cannot
 * be read, which is taken as seen: a dot that can never be cleared is worse than none.
 */
export function seenRelease(): string | null | undefined {
  try {
    return globalThis.localStorage?.getItem(SEEN_KEY) ?? null;
  } catch {
    return undefined;
  }
}

export function markSeen(id: string): void {
  try {
    globalThis.localStorage?.setItem(SEEN_KEY, id);
  } catch {
    // Storage refused: the dot stays, which is a nag and not a fault.
  }

  globalThis.dispatchEvent(new Event(SEEN_EVENT));
}
